import { BillRepository } from "../../repositories/BillRepository";
import {
  BillsResultEntity,
  BillStatus,
  BillListStatus,
  BillReviewStatus,
} from "../../entities/BillEntity";

/**
 * Get All Bills Use Case
 * Retrieves all bills with optional filtering and pagination
 */
export class GetAllBillsUseCase {
  constructor(private repository: BillRepository) {}

  async execute(params?: {
    limit?: number;
    offset?: number;
    status?: BillStatus | BillListStatus;
    reviewed?: BillReviewStatus;
    search?: string;
    companyid?: string;
    date_from?: string;
    date_to?: string;
    created_after?: string;
    created_before?: string;
    sort_by?:
      | "created_at"
      | "updated_at"
      | "filename"
      | "status"
      | "original_filename";
    sort_order?: "asc" | "desc";
  }): Promise<BillsResultEntity> {
    // Validate limit if provided
    if (params?.limit !== undefined && (params.limit < 1 || params.limit > 100)) {
      throw new Error("Limit must be between 1 and 100");
    }

    return await this.repository.fetchBills(params);
  }
}

